import Icon from '../components/Icon.vue'

Icon.register({
  egg: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M192 0c106 0 192 214 192 320s-86 192-192 192-192-86-192-192 86-320 192-320z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/egg.js
// module id = 1293
// module chunks = 0